import { RouterProvider, createRouter } from "@tanstack/react-router";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";

import * as TanStackQueryProvider from "./integrations/tanstack-query/root-provider.tsx";

// Import the generated route tree
import { routeTree } from "./routeTree.gen";

import "./styles.css";
import "./animate.css";
import { env } from "@/env";
import * as Sentry from "@sentry/react";
import { AudioPlayerProvider } from "react-use-audio-player";
import { Toaster } from "./components/ui/sonner.tsx";
import reportWebVitals from "./reportWebVitals.ts";

Sentry.init({
	dsn: env.VITE_SENTRY_DSN,
	sendDefaultPii: true,
	tracesSampleRate: import.meta.env.PROD ? 0.01 : 0.1,
	replaysSessionSampleRate: import.meta.env.PROD ? 0.01 : 0.1,
	replaysOnErrorSampleRate: 1.0,
	environment: import.meta.env.MODE,
	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.browserProfilingIntegration(),
		Sentry.browserSessionIntegration(),
		Sentry.replayIntegration(),
	],
	tracePropagationTargets: [],
});

// Create a new router instance
const router = createRouter({
	routeTree,
	context: {
		...TanStackQueryProvider.getContext(),
	},
	defaultPreload: false,
	scrollRestoration: true,
	defaultStructuralSharing: true,
	defaultPreloadStaleTime: 0,
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}
}

// Render the app
const rootElement = document.getElementById("app");
if (rootElement && !rootElement.innerHTML) {
	const root = ReactDOM.createRoot(rootElement);
	root.render(
		<StrictMode>
			<AudioPlayerProvider>
				<TanStackQueryProvider.Provider>
					<RouterProvider router={router} />
					<Toaster />
				</TanStackQueryProvider.Provider>
			</AudioPlayerProvider>
		</StrictMode>,
	);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
